//UAT
// export const environment = {
//   BASE_URL: 'VTJGc2RHVmtYMStHMTBTbkxoY2w5SWVTdmNtVWpkVEdPWldEM2NBUGtGNHFBYm0rclgzRmRQUWhGMDhBN0w3WTBmQk9zVzBROHZpZUNHZnlhaDdzNkE9PQ==',
//   SERVER_URL_POSITION: 'VTJGc2RHVmtYMSthdWtHQis4L2tmOVplLzdCTWJtaG9CMmdvN3VrWGh3cVMvSnFzZm1KaWJxYVdiaHYwRkVKalVNN2tZUjFuTEhmSG5PZUI2Y2JodWo3eStjNDVRTERwb1U5cUZDSjB4c2c9',
//   SERVER_URL_LOCALIZATION: 'VTJGc2RHVmtYMStqRUpjby9WUHJRdmZqbTc0YWIwSDZ0RGNvd0hPV1RDclVCeFNyQ0NQRnRXUmVlYXlRYzVkVXRQbXB1Y2liR1BzU0RCbzFYOUpBREtGeHRNRGRGUzlJU0F2d1dWZEcvTWM9',
//   KEY: 'U2FsdGVkX1+DOwV34q4SwOId+03wRvSi9tSYa0Skk/zEup46zMh83N+T6nhH4HNKbb0WOuzoLno6z35PVJlEYKTWzTPCXQBhGqynEdEvLFuRuRuEN5MNz6SP1cI4EjZv',
//   production: false
// };

//PROD
export const environment = {
  BASE_URL: 'VTJGc2RHVmtYMTlMcW1WMERaMUhxS0JzMEZ1UEF6eFVyeVB1WlZZS3pzWkMzbzRTWVJCdGFiMWx1WnE1Y1RJS21YT0NRMVgzVkQ0QklpTzlUa0tVR2c9PQ==',
  SERVER_URL_POSITION: 'VTJGc2RHVmtYMSthdWtHQis4L2tmOVplLzdCTWJtaG9CMmdvN3VrWGh3cVMvSnFzZm1KaWJxYVdiaHYwRkVKalVNN2tZUjFuTEhmSG5PZUI2Y2JodWo3eStjNDVRTERwb1U5cUZDSjB4c2c9',
  SERVER_URL_LOCALIZATION: 'VTJGc2RHVmtYMStqRUpjby9WUHJRdmZqbTc0YWIwSDZ0RGNvd0hPV1RDclVCeFNyQ0NQRnRXUmVlYXlRYzVkVXRQbXB1Y2liR1BzU0RCbzFYOUpBREtGeHRNRGRGUzlJU0F2d1dWZEcvTWM9',
  KEY: 'U2FsdGVkX1+DOwV34q4SwOId+03wRvSi9tSYa0Skk/zEup46zMh83N+T6nhH4HNKbb0WOuzoLno6z35PVJlEYKTWzTPCXQBhGqynEdEvLFuRuRuEN5MNz6SP1cI4EjZv',
  production: true
};